// Instellingen van het dashboard, centraal op één plek.

// Ontwerpmaat; het canvas wordt naar het echte scherm geschaald.
export const designWidth = 1920;
export const designHeight = 1080;

// Kolom 2 wisselt af tussen het podium en de rest van de ranglijst.
export const podiumViewMs = 30000;
export const restViewMs = 10000;

// Lijst "Verkochte diensten": rijafstand en doorrolsnelheid.
export const rowGapMin = 18; // px
export const rowGapMax = 40; // px
export const marqueeSpeed = 32; // px per seconde

// Ophalen van data.
export const cacheMs = 300000; // 5 minuten cache
export const retryMs = 20000; // wachttijd na een mislukte poging
export const tokenCheckMs = 30000; // nog ingelogd?
export const monthCheckMs = 60000; // maand omgeslagen?
export const clockTickMs = 60000;

// Muisaanwijzer verbergen na zoveel stilstand.
export const idleCursorMs = 30000;

// Geluid, per scherm uit met ?sound=off of via het animatielab.
export const soundVolume = 0.7; // 0 is stil, 1 is maximaal

// Extra volume voor de accentgeluiden (zie accented in audio/cues.js).
export const soundAccent = 1.6;

// Animaties bij nieuwe verkopen.
export const refreshMs = 60000; // hoe vaak we op nieuwe verkopen checken
// Vanaf deze bedragen komt er een tweede en derde confettibui.
export const mediumDealAmount = 500;
export const bigDealAmount = 1000;

// Confetti bij de aankondiging als deel van een volle bui, oplopend met het bedrag.
export const saleConfettiMin = 0.6;
export const saleConfettiMax = 1.2;
// Onder dit bedrag geen recordfeest.
export const recordMinAmount = 500;

// Drempel voor een eigen record; hoger omdat die vaker voorkomen.
export const personalBestMinAmount = 750;

// Tv-uit-detectie via de framerate (zie utils/screenAwake.js, per scherm ?dark=).
export const screenCheckMs = 2000; // hoe vaak we de frames tellen
export const screenMinFps = 3; // hieronder tekent dit scherm niet meer
export const screenDarkMs = 60000; // zo lang achter elkaar telt als tv uit

// Drempels voor de kaart "Verkopen gemist":
// - catchUpDarkMs: gemeten tv-uit-tijd, mag kort.
// - catchUpOfflineMs: ongemeten gat (Pi uit, geen netwerk); moet ruim boven
//   refreshMs blijven, anders verschijnt de kaart elke minuut.
export const catchUpDarkMs = 60000; // 1 minuut gemeten donker
export const catchUpOfflineMs = 300000; // 5 minuten ongemeten stilte

// Cijfertoetsen spelen animaties af op het dashboard; uit op de tv.
export const testShortcuts = false;
